module.exports = __webpack_public_path__ + "fonts/8211c6a3c53af95a7bf207a57d56505b.svg";